export default "__VITE_ASSET__1yMdR_Wh__"